<template>
  <div>
    <div class="text-4 font-weight-medium">Staking FAQs</div>
    <div class="d-flex flex-column flex-md-row justify-md-space-between mt-6">
      <div class="flex-1">
        <v-container class="pa-0">
          <v-row>
            <v-col cols="12" md="6" v-for="(item, idx) in items" :key="idx">
              <div class="border-default pa-4 rounded-8 height-100">
                <div class="text-5 font-weight-medium">{{ item.question }}</div>
                <div
                  class="mt-4 line-height-25 text-5 darkgray--text opacity-7"
                  v-html="item.answer"
                ></div>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </div>
      <div class="ml-10 mt-3 d-none d-md-block" style="width:160px">
        <div>
          <a
            href="https://docs.unagii.com"
            target="_blank"
            rel="noopener noreferrer"
            class="text-decoration-none black--text"
          >
            <c-btn is-default class="width-100">Docs</c-btn>
          </a>
        </div>
      </div>
      <div class="d-block d-md-none mt-10">
        <a
          href="https://docs.unagii.com"
          target="_blank"
          rel="noopener noreferrer"
          class="text-decoration-none black--text"
        >
          <c-btn is-default class="width-100">Docs</c-btn>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
import faqs from "@/common/config/faqs";
import { mapGetters } from "vuex";
export default {
  computed: {
    ...mapGetters({
      project: "projectConfig/latestProject",
    }),
    items() {
      return faqs[this.project.name] || [];
    },
  },
};
</script>
